export default __webpack_public_path__ + "static/hero-desktop-59bc30af3323373237df8ac7a28638eb.png";